import CommonConfig from 'fn-common-ui';

var config = Object.assign(CommonConfig.CommonConfig, {
  httpProtocol: 'https://',
  haloLogin: 'https://oidc.idp.flogin.att.com/mga/sps/oauth/oauth20/authorize?redirect_uri=https%3A%2F%2Ftraining.firstnet.att.com%2Foauth%2Fvalidate&scope=openid&nonce=AXgulLLOfRY1kxPjJDQw&response_type=id_token&response_mode=form_post&state=AXgulLLOfRY1kxPjJDQw&scope=openid&client_id=m22500',
  haloLogout: 'https://fcontent.att.com/dynamic/iamLRR/LrrController?IAM_OP=logout&appName=m22500',
  cspLogin: 'https://oidc.idp.elogin.att.com/mga/sps/oauth/oauth20/authorize?client_id=m22500&response_type=id_token+token&state=fnCue2diHaV9wxD7u9&nonce=ntQ7PGWFE6gsXm5Svoeg&redirect_uri=https://training.firstnet.att.com/oauth/validate&scope=openid+given_name+family_name+groups+email&response_mode=form_post',
  cspLogout: 'https://oidc.idp.elogin.att.com/pkmslogout',
  localControlFaq: 'https://localcontrol.firstnet.att.com/faq',
  adobeHeaderUrl: 'https://www.att.com/scripts/adobe/prod/detm-container-hdr.js',
  adobeFooterUrl: 'https://www.att.com/scripts/adobe/prod/detm-container-ftr.js'

});

export default config
